<!--
/*******************************************************************************
*@ 컴포넌트명   : interestRatesStep1ogauc.vue
*@ 컴포넌트설명 :[오클랜드] 예금 상품 > 금리 안내(당좌예금)
*@ 사용전문     :
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 2021.10.13   주형진  
********************************************************************************/
-->
<template>
  <div>
    <div class="cont-tit">
      <h6>NZD ({{ /*개인 고객*/ $t("MDEP-01-02-01-06") }})</h6>
      <div class="tbl-top-etc">{{ /*(연이율, 세전, 단위 : %)*/ $t("MDEP-01-02-01-08") }}</div>
    </div>
    <table class="table -type03">
      <thead>
        <tr>
          <th scope="col">
            $10,000
            <em>{{ /*이상*/ $t("MDEP-01-02-01-10") }}</em>
          </th>
          <th scope="col">
            $20,000
            <em>{{ /*이상*/ $t("MDEP-01-02-01-10") }}</em>
          </th>
          <th scope="col">
            $100,000
            <em>{{ /*이상*/ $t("MDEP-01-02-01-10") }}</em>
          </th>
          <th scope="col">
            $250,000
            <em>{{ /*이상*/ $t("MDEP-01-02-01-10") }}</em>
          </th>
          <th scope="col">
            $1,000,000
            <em>{{ /*이상*/ $t("MDEP-01-02-01-10") }}</em>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>0.00</td>
          <td>0.00</td>
          <td>0.00</td>
          <td>0.00</td>
          <td>0.00</td>
        </tr>
      </tbody>
    </table>
    <div class="cont-tit">
      <h6>NZD ({{ /*기업고객*/ $t("MDEP-01-02-01-07") }})</h6>
      <div class="tbl-top-etc">{{ /*(연이율, 세전, 단위 : %)*/ $t("MDEP-01-02-01-08") }}</div>
    </div>
    <table class="table -type03">
      <thead>
        <tr>
          <th scope="col">
            $10,000
            <em>{{ /*이상*/ $t("MDEP-01-02-01-10") }}</em>
          </th>
          <th scope="col">
            $20,000
            <em>{{ /*이상*/ $t("MDEP-01-02-01-10") }}</em>
          </th>
          <th scope="col">
            $100,000
            <em>{{ /*이상*/ $t("MDEP-01-02-01-10") }}</em>
          </th>
          <th scope="col">
            $250,000
            <em>{{ /*이상*/ $t("MDEP-01-02-01-10") }}</em>
          </th>
          <th scope="col">
            $1,000,000
            <em>{{ /*이상*/ $t("MDEP-01-02-01-10") }}</em>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>0.00</td>
          <td>0.00</td>
          <td>0.00</td>
          <td>0.00</td>
          <td>0.00</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      currentTab: 0,
    };
  },
};
</script>
